import { useAuth } from './useAuth';

/**
 * Whether current signed-in user is an admin user.
 * Admin is currently defined by the 'pdri' app role.
 */
export function useIsAdmin() {
  const { accounts } = useAuth();
  const roles = accounts?.[0]?.idTokenClaims?.roles || [];
  return roles.some((role) => String(role).toLowerCase() === 'pdri');
}
